.container {
  padding-bottom: 90px;
}

.card {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
}

.cardDealer {
  border-color: rgba(204, 255, 0, 0.4);
  background: rgba(204, 255, 0, 0.06);
}

.badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  padding: 4px 8px;
  border-radius: 100px;
  color: #010101;
  background: #ccff00;
  white-space: nowrap;
}

.check {
  flex-shrink: 0;
  margin-top: 2px;
}

/* The partner line's link (app#321): a link inside a sentence, its target the control's height —
   an atomic inline, so it neither overlaps the text around it nor shrinks below a finger. */
.partnerLink {
  display: inline-flex;
  align-items: center;
  min-height: var(--gac-control-touch-target);
  color: var(--gac-accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}
